import React from 'react';

import { Environment, Sky } from '@react-three/drei';

const MyEnvironment = React.memo(
  ({ castShadow = true }: { castShadow: boolean }) => {
    return (
      <>
        <Environment
          background={false} // can be true, false or "only" (which only sets the background) (default: false)
          files="env.hdr"
          path="/assets/3d/"
          scene={undefined} // adds the ability to pass a custom THREE.Scene, can also be a ref
        />
        <Sky
          distance={450000}
          sunPosition={[0, 1, 0]}
          inclination={0}
          azimuth={0.25}
        />
        <fog attach="fog" args={['#f1f1f1', 20, 50]} />
        <ambientLight intensity={0.5} />
        <directionalLight
          intensity={1}
          position={[4, 4, 2]}
          scale={1}
          shadow-mapSize={[4096, 4096]}
          castShadow={castShadow}
        />
      </>
    );
  }
);

export default MyEnvironment;
